import { ChangeLanguageService } from "./services/changeLanguage.service";

class LanguageChangeController {
	/*@ngInject*/
	constructor(public changeLanguageService: ChangeLanguageService) {

	}
}

export const LanguageChangeComponent = {
	selector: `changeLanguage`,
	controller: LanguageChangeController,
	controllerAs: "$ctrl",
	template: `
		<div class="langselect" ng-if="$ctrl.changeLanguageService.canSelectLanguage()">
			<select name="lang" class="form-control form-control-xs hidden-xs" size="1"
				ng-model="$ctrl.changeLanguageService.pageLanguage"
				ng-options="lang as lang.name for lang in $ctrl.changeLanguageService.languages track by lang.key"
				ng-change="$ctrl.changeLanguageService.changeLanguage()"
			></select>

			<select class="form-control form-control-xs visible-xs" name="lang" size="1"
				ng-model="$ctrl.changeLanguageService.pageLanguage"
				ng-options="lang as lang.shortName for lang in $ctrl.changeLanguageService.languages track by lang.key"
				ng-change="$ctrl.changeLanguageService.changeLanguage()"
			></select>
		</div>`
}